import { Modal, message } from 'antd';
import { oauthIp } from './oldUrl';
import mutex from './oldMutex';
// import { synchronizationUserInfo } from '../utils/sessionToLocal';
import { setUser } from '../actions/app';
import store from '../sotre';

export const requestFormLogin = (method, uri, body, release) => {
  const url = uri;
  method = method.toUpperCase();
  const formData = new FormData();
  Object.keys(body).forEach(key => {
    formData.append(key, body[key]);
  });
  return fetch(url, {
    method,
    mode: 'cors',
    headers: {
      Authorization: 'Basic TkpwNWdBZkZEV0ZLdUZWeXVGQ1A0QkJLOkNIc01FRVFXdjBZYkQ5bnRxdkU0R2ZNNTk1SlNQTDc3VkxDT2VpQmtmYnpjM3BhRw==',
    },
    body: formData,
  }).then((res) => {
    if (res.status === 200) {
      const datas = res.json().then((response) => {
        if (response.status === 'A0317' || response.status === 'A0303' || response.status === 'A0207' || response.status === 'A0305' || response.status === 'A0331') {
          if (localStorage.getItem('token')) {
            localStorage.setItem('token', '');
            Modal.warning({
              centered: true,
              content: '用户信息已过期，请重新登录！',
              okText: '重新登录',
              keyboard: false,
              onOk: () => {
                if (window.location.href.split('#')[1] === '/login') {
                  window.location.reload();
                } else {
                  store.dispatch(setUser(''));
                  window.location.href = `${window.location.href.split('#')[0]}#/login`;
                }
                localStorage.clear();
                localStorage.removeItem('rft');
                localStorage.removeItem('rftChanyeMax');
              },
              width: 416,
            });
          }
          return Promise.reject(new Error('Unauthorized.'));
        }
        if (response.access_token) {
          const maxTime = new Date().getTime() + (datas.expires_in * 1000 - 600 * 1000);
          localStorage.setItem('maxTime', maxTime);
          localStorage.setItem('token', `${datas.token_type} ${datas.access_token}`);
          localStorage.setItem('rft', `${datas.refresh_token}`);
          // synchronizationUserInfo({ token: `${datas.token_type} ${datas.access_token}`, maxTime, rft: datas.refresh_token });
          if (localStorage.getItem('rft')) {
            localStorage.setItem('rft', `${datas.refresh_token}`);
            // localStorage.setItem('cpToken', `${datas.token_type} ${datas.access_token}`);
            localStorage.setItem('cpMaxTime', maxTime);
          }
        }
        if (release) {
          release();
        }
        return response;
      });
      return datas;
    }
    localStorage.setItem('token', '');

    Modal.warning({
      centered: true,
      content: '用户信息已过期，请重新登录！',
      okText: '重新登录',
      keyboard: false,
      onOk: () => {
        if (window.location.href.split('#')[1] === '/login') {
          window.location.reload();
        } else {
          store.dispatch(setUser(''));
          window.location.href = `${window.location.href.split('#')[0]}#/login`;
        }
        localStorage.clear();
        localStorage.removeItem('rft');
        localStorage.removeItem('rftChanyeMax');
      },
      width: 416,
    });
    return undefined;
  }).catch(() => {
    localStorage.setItem('token', '');

    Modal.warning({
      centered: true,
      content: '用户信息已过期，请重新登录！',
      okText: '重新登录',
      keyboard: false,
      onOk: () => {
        if (window.location.href.split('#')[1] === '/login') {
          window.location.reload();
        } else {
          store.dispatch(setUser(''));
          window.location.href = `${window.location.href.split('#')[0]}#/login`;
        }
        localStorage.clear();
        localStorage.removeItem('rft');
        localStorage.removeItem('rftChanyeMax');
      },
      width: 416,
    });
    return undefined;
  });
};

export const postFormLoginRefresh = (url, body, release) => requestFormLogin('POST', url, body, release);

export const postFormLogin = (url, body) => requestFormLogin('POST', url, body);

function refreshToken(release) {
  postFormLoginRefresh(`${oauthIp}/token`, {
    grant_type: 'refresh_token',
    refresh_token: localStorage.getItem('rft') || '',
  }, release);
}

export default async function request(method, uri, body) {
  let url = uri;
  method = method.toUpperCase();
  if (method === 'GET') {
    const a = [];
    Object.keys(body).forEach(key => {
      a.push(`${key}=${body[key]}`);
    });
    if (a.length > 0) {
      url += `?${a.join('&')}`;
    }
    body = undefined;
  } else {
    body = body && JSON.stringify(body);
  }

  let credentials = 'same-origin';

  if (process.env.NODE_ENV === 'production') {
    credentials = 'include';
  }
  await mutex.waitForUnlock();
  const maxTime = localStorage.getItem('maxTime');
  const nowTime = new Date().getTime();
  const token = localStorage.getItem('token');
  const rft = localStorage.getItem('rft');
  if (nowTime >= maxTime && !mutex.isLocked() && token && rft) {
    const release = await mutex.acquire();
    await refreshToken(release);
  }
  // else {
  await mutex.waitForUnlock();
  const result = await fetch(url, {
    method,
    mode: 'cors',
    credentials,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json,text/plain,*/*',
      Authorization: localStorage.getItem('token') || '',
    },
    body,
  }).then((res) => {
    // 先单独加了401判断,原先本身是有的,后面不知道为啥删掉了这个,猜测可能是因为文件流的接口调用会影响
    if (res.status === 401) {
      if (localStorage.getItem('token')) {
        localStorage.setItem('token', '');

        Modal.warning({
          centered: true,
          content: '用户信息已过期，请重新登录！',
          okText: '重新登录',
          keyboard: false,
          onOk: () => {
            if (window.location.href.split('#')[1] === '/login') {
              window.location.reload();
            } else {
              store.dispatch(setUser(''));
              window.location.href = `${window.location.href.split('#')[0]}#/login`;
            }
            localStorage.clear();
            localStorage.removeItem('rft');
            localStorage.removeItem('rftChanyeMax');
          },
          width: 416,
        });
      }
      return Promise.reject(new Error('Unauthorized.'));
    }
    const datas = res.json().then((response) => response);
    return datas;
  }).catch(() => ({ status: -1, message: '数据加载异常...' }));
  // }
  return result;
}

export const get = (url, body) => request('GET', url, body);
export const getSource = (url, body) => request('GET', url, body, true);
export const post = (url, body) => request('POST', url, body);
export const put = (url, body) => request('PUT', url, body);
export const del = (url, body) => request('DELETE', url, body);

// FormData
export const requestForm = async ({ method, uri, body, fixed }) => {
  const url = uri;
  method = method.toUpperCase();
  const formData = new FormData();
  Object.keys(body).forEach(key => {
    formData.append(key, body[key]);
  });

  let header;

  if (fixed) {
    header = {
      Authorization: 'Basic TkpwNWdBZkZEV0ZLdUZWeXVGQ1A0QkJLOkNIc01FRVFXdjBZYkQ5bnRxdkU0R2ZNNTk1SlNQTDc3VkxDT2VpQmtmYnpjM3BhRw==',
    };
  }
  await mutex.waitForUnlock();
  const maxTime = localStorage.getItem('maxTime');
  const nowTime = new Date().getTime();
  const token = localStorage.getItem('token');
  const rft = localStorage.getItem('rft');
  if (nowTime >= maxTime && !mutex.isLocked() && token && rft) {
    const release = await mutex.acquire();
    await refreshToken(release);
  }
  // else {
  await mutex.waitForUnlock();
  const result = await fetch(url, {
    method,
    mode: 'cors',
    headers: {
      Authorization: localStorage.getItem('token') || '',
      ...header,
    },
    body: formData,
  }).then((res) => {
    const datas = res.json().then((response) => {
      if (response.status === 'A0317' || response.status === 'A0303' || response.status === 'A0207' || response.status === 'A0331') {
        if (localStorage.getItem('token')) {
          localStorage.setItem('token', '');

          Modal.warning({
            centered: true,
            content: '用户信息已过期，请重新登录！',
            okText: '重新登录',
            keyboard: false,
            onOk: () => {
              if (window.location.href.split('#')[1] === '/login') {
                window.location.reload();
              } else {
                store.dispatch(setUser(''));
                window.location.href = `${window.location.href.split('#')[0]}#/login`;
              }
              localStorage.clear();
              localStorage.removeItem('rft');
              localStorage.removeItem('rftChanyeMax');
            },
            width: 416,
          });
        }
        return Promise.reject(new Error('Unauthorized.'));
      }
      return response;
    });
    return datas;
  }).catch(() => ({ status: -1, message: '数据加载异常...' }));
  // }
  return result;
};
export function requestFormXHR(options = {}) {
  const { url, method = 'GET', data = null, uploadProgress } = options;
  const token = localStorage.getItem('token');

  return new Promise((resolve, reject) => {
    const handler = (res) => {
      const { currentTarget } = res;
      const { readyState, status } = currentTarget;
      if (readyState === 4) {
        if (status === 'A0317' || status === 'A0303' || status === 'A0207' || status.status === 'A0331') {
          if (localStorage.getItem('token')) {
            localStorage.setItem('token', '');

            Modal.warning({
              centered: true,
              content: '用户信息已过期，请重新登录！',
              okText: '重新登录',
              keyboard: false,
              onOk: () => {
                if (window.location.href.split('#')[1] === '/login') {
                  window.location.reload();
                } else {
                  store.dispatch(setUser(''));
                  window.location.href = `${window.location.href.split('#')[0]}#/login`;
                }
                localStorage.clear();
                localStorage.removeItem('rft');
                localStorage.removeItem('rftChanyeMax');
              },
              width: 416,
            });
          }
          reject(new Error('token失效'));
        } else {
          resolve(currentTarget.response);
        }
      }
    };
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.upload.addEventListener('progress', uploadProgress);
    xhr.responseType = 'json';
    xhr.setRequestHeader('Authorization', token);
    xhr.onreadystatechange = handler;
    xhr.send(data);
  });
}
export const postForm = (url, body) => requestForm({ method: 'POST', uri: url, body });

// 分析引擎新建报告
export const formDataRequest = async (method, uri, body) => {
  const url = uri;
  method = method.toUpperCase();
  const formData = new FormData();
  body.pic_list.forEach(item => {
    formData.append('pic_list', item, item.name);
  });
  delete body.pic_list;
  Object.keys(body).forEach(key => {
    formData.append(key, body[key]);
  });
  await mutex.waitForUnlock();
  const maxTime = localStorage.getItem('maxTime');
  const nowTime = new Date().getTime();
  const token = localStorage.getItem('token');
  const rft = localStorage.getItem('rft');
  if (nowTime >= maxTime && !mutex.isLocked() && token && rft) {
    const release = await mutex.acquire();
    await refreshToken(release);
  }
  // else {
  await mutex.waitForUnlock();
  const result = await fetch(url, {
    method,
    mode: 'cors',
    headers: {
      Authorization: localStorage.getItem('token') || '',
    },
    body: formData,
  }).then((res) => {
    const datas = res.json().then((response) => {
      if (response.status === 'A0317' || response.status === 'A0303' || response.status === 'A0207' || response.status === 'A0331') {
        if (localStorage.getItem('token')) {
          localStorage.setItem('token', '');
          Modal.warning({
            centered: true,
            content: '用户信息已过期，请重新登录！',
            okText: '重新登录',
            keyboard: false,
            onOk: () => {
              if (window.location.href.split('#')[1] === '/login') {
                window.location.reload();
              } else {
                store.dispatch(setUser(''));
                window.location.href = `${window.location.href.split('#')[0]}#/login`;
              }
              localStorage.clear();
              localStorage.removeItem('rft');
              localStorage.removeItem('rftChanyeMax');
            },
            width: 416,
          });
        }
        return Promise.reject(new Error('Unauthorized.'));
      }
      return response;
    });
    return datas;
  }).catch(() => ({ status: -1, message: '数据加载异常...' }));
  // }
  return result;
};

export const formDataRequestPost = (url, body) => formDataRequest('POST', url, body);

export const requestBinary = (method, uri, body) => {
  let url = uri;
  method = method.toUpperCase();
  if (method === 'GET') {
    const a = [];
    Object.keys(body).forEach(key => {
      a.push(`${key.toString()}=${body[key].toString()}`);
    });
    if (a.length > 0) {
      url += `?${a.join('&')}`;
    }
    body = undefined;
  } else {
    body = body && JSON.stringify(body);
  }

  return fetch(url, {
    method,
    mode: 'cors',
    credentials: 'include',
    headers: {
      Accept: 'application/octet-stream,text/plain,*/*',
      Authorization: localStorage.getItem('token') || '',
    },
    body,
  }).then(res => {
    if (res.status === 401) {
      if (localStorage.getItem('token')) {
        localStorage.setItem('token', '');
        Modal.warning({
          centered: true,
          content: '用户信息已过期，请重新登录！',
          okText: '重新登录',
          keyboard: false,
          onOk: () => {
            if (window.location.href.split('#')[1] === '/login') {
              window.location.reload();
            } else {
              store.dispatch(setUser(''));
              window.location.href = `${window.location.href.split('#')[0]}#/login`;
            }
            localStorage.clear();
            localStorage.removeItem('rft');
            localStorage.removeItem('rftChanyeMax');
          },
          width: 416,
        });
      }
      return Promise.reject(new Error('Unauthorized.'));
    }
    return res.arrayBuffer();
  });
};

export const protoGet = (url, body) => requestBinary('GET', url, body);
export const protoPost = (url, body) => requestBinary('POST', url, body);

export const requestFile = async (method, uri, body, filename, requestMsg, header, text = '文件下载中...') => {
  message.loading(text, 0);
  let url = uri;
  method = method.toUpperCase();
  if (method === 'GET') {
    const a = [];
    Object.keys(body).forEach(key => {
      a.push(`${key.toString()}=${body[key].toString()}`);
    });
    if (a.length > 0) {
      url += `?${a.join('&')}`;
    }
    body = undefined;
  } else {
    body = body && JSON.stringify(body);
  }
  await mutex.waitForUnlock();
  const maxTime = localStorage.getItem('maxTime');
  const nowTime = new Date().getTime();
  const token = localStorage.getItem('token');
  const rft = localStorage.getItem('rft');
  if (nowTime >= maxTime && !mutex.isLocked() && token && rft) {
    const release = await mutex.acquire();
    await refreshToken(release);
  }
  // else {
  await mutex.waitForUnlock();
  const result = await fetch(url, {
    method,
    mode: 'cors',
    headers: {
      Accept: 'application/json,text/plain,*/*',
      Authorization: localStorage.getItem('token') || '',
      ...header,
    },
    body,
  }).then((res) => {
    if (res.status === 401) {
      if (localStorage.getItem('token')) {
        localStorage.setItem('token', '');
        Modal.warning({
          centered: true,
          content: '用户信息已过期，请重新登录！',
          okText: '重新登录',
          keyboard: false,
          onOk: () => {
            if (window.location.href.split('#')[1] === '/login') {
              window.location.reload();
            } else {
              store.dispatch(setUser(''));
              window.location.href = `${window.location.href.split('#')[0]}#/login`;
            }
            localStorage.clear();
            localStorage.removeItem('rft');
            localStorage.removeItem('rftChanyeMax');
          },
          width: 416,
        });
      }
      return Promise.reject(new Error('Unauthorized.'));
    }
    if (res.status === 402) {
      return res.json();
    }
    if (requestMsg) {
      return res.json();
    }
    return res.blob().then((blob) => {
      const aLink = document.createElement('a');
      document.body.appendChild(aLink);
      aLink.style.display = 'none';
      const objectUrl = window.URL.createObjectURL(blob);
      aLink.href = objectUrl;
      aLink.download = filename;
      aLink.click();
      document.body.removeChild(aLink);
      message?.destroy();
      message.success('下载成功！', 1);
    }).catch(() => {
      message.warning('下载失败！', 1);
    });
  });
  // }
  return result;
};

export const requestHtml = (method, uri, body) => {
  let url = uri;
  method = method.toUpperCase();
  if (method === 'GET') {
    const a = [];
    Object.keys(body).forEach(key => {
      a.push(`${key.toString()}=${body[key].toString()}`);
    });
    if (a.length > 0) {
      url += `?${a.join('&')}`;
    }
    body = undefined;
  } else {
    body = body && JSON.stringify(body);
  }

  return fetch(url, {
    method,
    mode: 'cors',
    headers: {
      Accept: 'application/json,text/plain,*/*',
      Authorization: localStorage.getItem('token') || '',
    },
    body,
  }).then((res) => {
    if (res.status === 401) {
      if (localStorage.getItem('token')) {
        localStorage.setItem('token', '');
        Modal.warning({
          centered: true,
          content: '用户信息已过期，请重新登录！',
          okText: '重新登录',
          keyboard: false,
          onOk: () => {
            if (window.location.href.split('#')[1] === '/login') {
              window.location.reload();
            } else {
              store.dispatch(setUser(''));
              window.location.href = `${window.location.href.split('#')[0]}#/login`;
            }
            localStorage.clear();
            localStorage.removeItem('rft');
            localStorage.removeItem('rftChanyeMax');
          },
          width: 416,
        });
      }
      return Promise.reject(new Error('Unauthorized.'));
    } if (res.status === 402) {
      return res.json();
    }
    return res.blob().then((blob) => {
      const objectUrl = window.URL.createObjectURL(blob);
      const win = window.open(objectUrl, '_blank');
      win.focus();
    });
  });
};

export const requestCatpcha = (method, uri, body) => {
  let url = uri;
  method = method.toUpperCase();
  if (method === 'GET') {
    const a = [];
    Object.keys(body).forEach(key => {
      a.push(`${key.toString()}=${body[key].toString()}`);
    });
    if (a.length > 0) {
      url += `?${a.join('&')}`;
    }
    body = undefined;
  } else {
    body = body && JSON.stringify(body);
  }

  return fetch(url, {
    method,
    mode: 'cors',
    headers: {
      Accept: 'application/json,text/plain,*/*',
    },
    body,
  }).then((res) => {
    if (res.status === 401) {
      if (localStorage.getItem('token')) {
        localStorage.setItem('token', '');
        Modal.warning({
          centered: true,
          content: '用户信息已过期，请重新登录！',
          okText: '重新登录',
          keyboard: false,
          onOk: () => {
            if (window.location.href.split('#')[1] === '/login') {
              window.location.reload();
            } else {
              store.dispatch(setUser(''));
              window.location.href = `${window.location.href.split('#')[0]}#/login`;
            }
            localStorage.clear();
            localStorage.removeItem('rft');
            localStorage.removeItem('rftChanyeMax');
          },
          width: 416,
        });
      }
      return Promise.reject(new Error('Unauthorized.'));
    }
    return res;
  });
};

export const urlHasKey = (props, key) => {
  const { search } = props.history.location;
  if (search.length > 0 && search[0] === '?') {
    const kvList = search.substr(1).split('&');
    for (let i = 0; i < kvList.length; ++i) {
      const kv = kvList[i].split('=');
      if (kv.length === 2 && kv[0] === key) {
        return true;
      }
    }
  }
  return false;
};

export const urlGetValue = (props, key, defaultValue) => {
  const { search } = props.history.location;
  if (search.length > 0 && search[0] === '?') {
    const kvList = search.substr(1).split('&');
    for (let i = 0; i < kvList.length; ++i) {
      const kv = kvList[i].split('=');
      if (kv.length === 2 && kv[0] === key) {
        return kv[1];
      }
    }
  }
  return defaultValue;
};

export const urlGetInt = (props, key, defaultValue = 0) => {
  const { search } = props.history.location;
  if (search.length > 0 && search[0] === '?') {
    const kvList = search.substr(1).split('&');
    for (let i = 0; i < kvList.length; ++i) {
      const kv = kvList[i].split('=');
      if (kv.length === 2 && kv[0] === key) {
        return parseInt(kv[1]);
      }
    }
  }
  return defaultValue;
};

export const formUrl = (uri, obj) => {
  const a = [];
  Object.keys(obj).forEach(key => {
    a.push(`${key.toString()}=${obj[key].toString()}`);
  });
  if (a.length > 0) {
    return `${uri}?${a.join('&')}`;
  }
  return uri;
};

export const getUserId = () => {
  const userId = localStorage.getItem('star_user_id');
  if (userId) {
    return userId;
  }
  return 0;
};
